(function() {
    'use strict';

    angular.module('app.application.role', [
        'app.core'
      ]);
})();
